module.exports = __webpack_public_path__ + "images/goat-23522672563eaec300cacc4196daeb5f.png";